export class SortIngestionPipelineDeadLetterBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "IngestionPipelineDeadLetterSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortIngestionPipelineDeadLetterBy.attributeTypeMap;
    }
    constructor() {
    }
}
